import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import Vue from 'vue';
export default {
  name: 'IwsVideo',
  props: {
    width: {
      type: Number,
      required: false,
      default: 600
    },
    height: {
      type: Number,
      required: false,
      default: 400
    },
    DeviceSerial: {
      //设备序列号
      type: String,
      required: false,
      default: ''
    },
    DeviceCode: {
      //设备验证码
      type: String,
      required: false,
      default: ''
    },
    DeviceType: {
      //平台类型模式: 1.摄像头2.云台
      type: Number,
      required: false,
      default: 1
    },
    DeviceName: {
      type: String,
      required: true
    },
    channel: {
      //通道号摄像头默认为1,nvr有多个通道
      type: Number,
      required: false,
      default: 1
    },
    dpi: {
      //HD高清地址后缀.hd.live SD流畅地址后缀.live
      type: String,
      required: false,
      default: 'SD'
    },
    templete: {
      //播放器模式: 0极简版 1标准版
      type: Number,
      required: false,
      default: 1
    },
    type: {
      //平台类型模式: 1.萤石云 2.拾联平台
      type: Number,
      required: false,
      default: 1
    },
    autoplay: {
      //是否自动播放: 1.自动 0.手动
      type: String,
      required: false,
      default: '0'
    },
    siteId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      videosrc: ''
    };
  },
  created: function created() {
    // getAction('/sys/video/view/hik/'+ this.DeviceSerial).then(res=>{
    //
    // })
    this.reloadurl();
  },
  watch: {
    DeviceSerial: function DeviceSerial(val) {
      this.reloadurl();
    },
    DeviceCode: function DeviceCode(val) {
      this.reloadurl();
    },
    channel: function channel(val) {
      this.reloadurl();
    },
    dpi: function dpi(val) {
      this.reloadurl();
    },
    templete: function templete(val) {
      this.reloadurl();
    },
    type: function type(val) {
      this.reloadurl();
    },
    DeviceType: function DeviceType(val) {
      this.reloadurl();
    }
  },
  methods: {
    reloadurl: function reloadurl() {
      var _this = this;

      console.log('reloadurl', this.type, this.DeviceSerial);
      var videourl = '';

      if (this.type && this.type == 2) {
        videourl = location.origin + '/Live/view.html';

        if (this.DeviceSerial && this.DeviceSerial.length > 0) {
          //获取平台token
          getAction('/sys/video/token?type=' + this.type).then(function (res) {
            if (res.success) {
              if (res.result) {
                if (res.result.token) {
                  videourl += '?tk=' + res.result.token + '&deviceSerial=' + _this.DeviceSerial + '&autoplay=' + _this.autoplay + '&channel=' + _this.channel + '&type=' + _this.type + '&deviceType=' + _this.DeviceType + '&siteId=' + _this.siteId;
                }
              }
            }

            _this.videosrc = videourl;
          }).catch(function (error) {// this.videosrc = location.origin + '/Live/view.html'
          });
        }
      } else if (this.type && this.type == 3) {
        videourl = location.origin + '/HK/view.html';

        if (this.DeviceSerial) {
          videourl = location.origin + '/HK/view.html?deviceType=' + this.DeviceType + '&siteId=' + this.siteId + '&deviceSerial=' + this.DeviceSerial + '&channel=' + this.channel + '&type=' + this.type + '&token=' + Vue.ls.get(ACCESS_TOKEN);
          this.videosrc = videourl; // getAction(`/sys/video/view/hik/${this.DeviceSerial}/${this.siteId}`).then(res => {
          //   if (res.success) { 
          //   }else{
          //     this.$message.warning('取流失败,请检查流媒体平台是否正常......')
          //   }
          // }).catch((error) => {
          //   // this.videosrc = location.origin + '/HK/view.html'
          // })
        }
      } else if (this.type && this.type == 1) {
        videourl = location.origin + '/EZUIKit/iframe_se.html?url='; //构建url地址

        if (this.DeviceCode && this.DeviceCode.length > 0) {
          videourl += 'ezopen://' + this.DeviceCode + '@open.ys7.com/';
        } else {
          videourl += 'ezopen://open.ys7.com/';
        }

        if (this.DeviceSerial && this.DeviceSerial.length > 0) {
          var dpi = this.dpi == 'HD' ? '.hd.live' : '.live';
          var templete = this.templete && this.templete >= 0 && this.templete <= 4 ? this.templete : 0;
          var token = Vue.ls.get(ACCESS_TOKEN); //获取平台token

          getAction('/sys/video/token?type=' + this.type).then(function (res) {
            if (res.success) {
              if (res.result) {
                if (res.result.token) {
                  videourl += _this.DeviceSerial + '/' + _this.channel + dpi + '&autoplay=0&audio=1&accessToken=' + res.result.token + '&templete=' + templete + '&deviceSerial=' + _this.DeviceSerial + '&channel=' + _this.channel + '&token=' + token + '&siteId=' + _this.siteId;
                }
              }
            }

            console.log(videourl);
            _this.videosrc = videourl;
          }).catch(function (error) {// this.videosrc = location.origin + '/EZUIKit/iframe_se.html?autoplay=0'
          });
        }
      }
    },
    ptzcontroller: function ptzcontroller(status, direction, msg) {
      var _this2 = this;

      var pram = {
        type: this.type,
        deviceSerial: this.DeviceSerial,
        direction: direction,
        status: status,
        channel: this.channel,
        siteId: this.siteId
      };
      getAction('/sys/video/ptz', pram).then(function (res) {
        if (res.success && msg) {// this.$notification.warning({ message: res.message })
        }
      }).catch(function (error) {
        if (msg) _this2.$notification.success({
          message: '操作失败!'
        });
      });
    },
    ptztimeout: function ptztimeout(direction, timeout) {
      var _this3 = this;

      this.ptzcontroller('start', direction, false);
      setTimeout(function () {
        _this3.ptzcontroller('stop', direction, false);
      }, timeout);
    },
    startptz: function startptz(direction) {
      this.ptzcontroller('start', direction, true);
    },
    stopptz: function stopptz(direction) {
      this.ptzcontroller('stop', direction, true);
    }
  }
};